import { ActionPointInfo, Controller, IActionPointInfo, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/export-file/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ExportFileFeature } from '@framework/workbench/ui/export-file/export-file-feature';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig, ToolbarFileMenuConfig, FileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import i18n from '@i18next/i18n';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isEditableDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { MenuKey } from '../../schema/menu-schema/common';

@Controller({ menuItems: MENU_CONFIGS })
export class ExportFileController {
    public constructor(private readonly exportFileFeature: ExportFileFeature) {}

    @Menu(ActionType.EXPORT, 'shouldDisabled')
    @Menu(MenuKey.EXPORT_HOR, 'shouldDisabled')
    public handleDisabled() {
        return !SlideDataServices.PrivilegeManager()?.exportable;
    }

    @Menu(ActionType.EXPORT, 'popUpStyle')
    public popupStyle() {
        return {
            width: '194px',
        };
    }

    @Menu(ActionType.NATIVE_PPT, 'onClick')
    @Menu(MenuKey.EXPORT_HOR, 'onClick')
    public exportNative() {
        this.exportFileFeature.exportNative();
    }

    @Menu(ActionType.EXPORT_PDF, 'onClick')
    public exportPDF() {
        this.exportFileFeature.exportPDF();
    }

    @Menu(ActionType.EXPORT_IMAGE, 'onClick')
    public exportImage() {
        this.exportFileFeature.exportImage();
    }

    @Menu(ActionType.EXPORT_IMAGE, 'shouldHide')
    public shouldHideExportImage() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.exportImg as any) ?? true);
    }

    @Menu(ActionType.NATIVE_PPT, 'shouldHide')
    @Menu(MenuKey.EXPORT_HOR, 'shouldHide')
    public shouldHideExportPpt() {
        return !(appConfigInstance.getConfig(TitlebarFileMenuConfig.exportPpt as any) ?? true);
    }

    @Menu(ActionType.EXPORT_PDF, 'shouldHide')
    public shouldHideExportPdf() {
        return !(appConfigInstance.getConfig(TitlebarFileMenuConfig.exportPdf as any) ?? true);
    }

    @Menu(ActionType.EXPORT_PDF, 'shouldHide')
    public shouldHideExportShortcut() {
        return !(appConfigInstance.getConfig(TitlebarFileMenuConfig.exportShortcut as any) ?? true);
    }

    @Menu(ActionType.EXPORT_IMAGE, 'content')
    public getContent(@ActionPointInfo() info:  IActionPointInfo) {
        if (info.path.includes(ActionType.EXPORT)) {
            return i18n.t<string>('图片(.png)');
        }
        return i18n.t<string>('生成图片');
    }

    @Menu(ActionType.EXPORT_PDF, 'content')
    public exportPDFContent() {
        return  browser.isWxMiniProgram ? i18n.t<string>('在线PDF文档') : i18n.t<string>('PDF文档');
    }

    @Menu(ActionType.GENERATE_SHORTCUT, 'onClick')
    public exportShortcut() {
        this.exportFileFeature.exportShortcut();
    }

    @Menu(ActionType.EXPORT, 'shouldHide')
    public handleHide() {
        // exportAs: true优先， 本地编辑是simplifyMode，但依然要显示导出
        if (appConfigInstance.getConfig(FileMenuConfig.exportAs as any)) return false;
        return (
            !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false)
            || !((appConfigInstance.getConfig(FileMenuConfig.exportAs as any) ?? true))
        );
    }
}
